import React, { useState, useEffect } from "react";
import ModaleParametreAffichage from "./ModaleParametreAffichage";
import useLocalStorage from "../Hooks/useLocalStorage";
import useSystemThemeDetector from "../Hooks/useSystemThemeDetector";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025.
 */
var FooterLiens = function (_a) {
    var children = _a.children, activerParametrageTheme = _a.activerParametrageTheme, valeurInitialeTheme = _a.valeurInitialeTheme;
    var _b = useState(false), modaleThemeOuverte = _b[0], setModaleThemeOuverte = _b[1];
    var scheme = useLocalStorage("scheme", valeurInitialeTheme !== null && valeurInitialeTheme !== void 0 ? valeurInitialeTheme : "system")[0];
    var _c = useState(scheme), theme = _c[0], setTheme = _c[1];
    var isDarkSystemTheme = useSystemThemeDetector();
    // Appliquer le theme
    useEffect(function () {
        var themeActuel = theme;
        if (theme === "system" && isDarkSystemTheme) {
            themeActuel = "dark";
        }
        if (theme === "system" && !isDarkSystemTheme) {
            themeActuel = "light";
        }
        document.getElementsByTagName("html")[0].setAttribute("data-fr-theme", themeActuel);
    }, [theme, isDarkSystemTheme]);
    return (React.createElement("ul", { className: "fr-footer__bottom-list" },
        children,
        activerParametrageTheme && (React.createElement("li", { className: "fr-footer__bottom-item" },
            React.createElement("button", { type: "button", className: "fr-footer__bottom-link fr-fi-theme-fill fr-link--icon-left", "aria-controls": "fr-theme-modal", "data-fr-opened": "false", onClick: function () { return setModaleThemeOuverte(true); } }, "Param\u00E8tres d'affichage"),
            modaleThemeOuverte && (React.createElement(ModaleParametreAffichage, { closeCallback: function () { return setModaleThemeOuverte(false); }, changerThemeCallback: function (theme) { return setTheme(theme); } }))))));
};
export default FooterLiens;
